import { useTranslation } from 'react-i18next';

import { OpEmpty } from 'new-components/DLS/OpEmpty/OpEmpty';
import { opTime } from 'utils/dates';
import { OpList } from 'new-components/DLS/OpList/OpList';
import { OpTypography } from 'new-components/DLS/OpTypography/OpTypography';

import { QrCodeScanLog } from '../../../../../types/qrCodeTypes';
import { DATE_TIME_AM_PM_FORMAT } from '../../../../../constants/dates';

interface QrCodeTabProps {
  qrCodeScanLogs: QrCodeScanLog[];
}

const QrCodeTab = ({ qrCodeScanLogs }: QrCodeTabProps) => {
  const { t } = useTranslation();
  return (
    <OpList
      header={
        <OpTypography.Text>
          {t('visitors.profile.qrCode.title')}
        </OpTypography.Text>
      }
      bordered
      dataSource={qrCodeScanLogs}
      locale={{
        emptyText: (
          <OpEmpty description={t('visitors.profile.qrCode.noData')} />
        ),
      }}
      renderItem={(item) => {
        const scanLog = item as QrCodeScanLog;
        return (
          <OpList.Item>
            <OpTypography.Text>
              {opTime
                .utc(scanLog.scannedUtc)
                .local()
                .format(DATE_TIME_AM_PM_FORMAT)}
            </OpTypography.Text>
            <OpTypography.Text>{scanLog.source}</OpTypography.Text>
          </OpList.Item>
        );
      }}
    />
  );
};

export default QrCodeTab;
